import { render, staticRenderFns } from "./SamEmptyState.vue?vue&type=template&id=c161372a&scoped=true&"
import script from "./SamEmptyState.vue?vue&type=script&lang=js&"
export * from "./SamEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./SamEmptyState.vue?vue&type=style&index=0&id=c161372a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c161372a",
  null
  
)

export default component.exports